// Форма фильтра

import {h} from 'preact';
import {debouncedFetchList} from './asyncActions/fetchList';
import {debouncedFetchVisualBuilding} from './asyncActions/fetchVisualBuilding';
import {debouncedFetchVisualFloor} from './asyncActions/fetchVisualFloor';
import {debouncedFetchVisualOverview} from './asyncActions/fetchVisualOverview';
import {debouncedFetchVisualSection} from './asyncActions/fetchVisualSection';
import FilterCheckboxes from './FilterCheckboxes';
import FilterRange from './FilterRange';
import FilterSections from './FilterSections';
import * as Creators from './Store/creators/filter';
import {dispatch, getState, SubscribedComponent} from './Store/index';
import State, {StateFilterCheckbox, StateFilterRange, StateVisualStep} from './Store/State';
import listStateToQueryString from './utils/listStateToQueryString';
import updateAddress from './utils/updateAddress';
import visualStateToQueryString from './utils/visualStateToQueryString';

/**
 * Component Properties
 */
interface FilterFormProps
{
	[key: string]: void;
}

/**
 * Component State
 */
interface FilterFormState
{
	/** Секция */
	section: StateFilterCheckbox[];
	/** Этаж */
	floor: StateFilterRange;
	/** Тип комнат */
	roomType: StateFilterCheckbox[];
	/** Общая площадь, м² */
	squareTotal: StateFilterRange;
	/** Общая цена */
	totalCost: StateFilterRange;
}

/**
 * Форма фильтра.
 */
class FilterForm extends SubscribedComponent<State, FilterFormProps, FilterFormState>
{
	/**
	 * Render component
	 */
	public render(
		_props: FilterFormProps,
		{section, floor, roomType, squareTotal, totalCost}: FilterFormState,
	): JSX.Element
	{
		return (
			<form
				name="filter"
				method="GET"
				action="javascript:"
				onChange={this.onChange}
			>
				<ul class="fields">
					<FilterSections
						formName="filter"
						baseName="section"
						label="Секция"
						items={section}
					/>
					<FilterRange
						formName="filter"
						label="Этаж"
						name="floor"
						step={1}
						{...floor}
					/>
					<FilterCheckboxes
						formName="filter"
						baseName="roomType"
						label="Количество комнат"
						items={roomType}
					/>
					<FilterRange
						formName="filter"
						label="Площадь, м²"
						name="squareTotal"
						step={0.01}
						{...squareTotal}
					/>
					<FilterRange
						formName="filter"
						label="Стоимость, руб."
						name="totalCost"
						step={1}
						{...totalCost}
					/>
				</ul>
				<a href="/choose/apartment/?mode=list">Сбросить фильтры</a>
			</form>
		);
	}
	
	/**
	 * Handle Store changes.
	 */
	protected storeStateChanged(
		{filter}: State,
	): void
	{
		const {section, floor, roomType, squareTotal, totalCost} = filter;
		
		if (
			( section === this.state.section )
			&& ( floor === this.state.floor )
			&& ( roomType === this.state.roomType )
			&& ( squareTotal === this.state.squareTotal )
			&& ( totalCost === this.state.totalCost )
		)
		{
			return;
		}
		
		this.setState( {section, floor, roomType, squareTotal, totalCost} );
		
		// TODO:
		/*debouncedFetchList(
			listStateToQueryString(
				filter,
			),
		);*/
	}
	
	/**
	 * Обрабатывает изменения на форме.
	 */
	private onChange = ( event: Event ): void =>
	{
		const target = event.target as HTMLInputElement;
		const {name, value} = target;
		
		switch ( name )
		{
			case 'section[]':
				dispatch( Creators.toggleSection( value ) );
				break;
			
			case 'roomType[]':
				dispatch( Creators.toggleRoomType( value ) );
				break;
			
			case 'floorFrom':
				dispatch( Creators.setFloorFrom( parseInt( value, 10 ) ) );
				break;
			
			case 'floorTo':
				dispatch( Creators.setFloorTo( parseInt( value, 10 ) ) );
				break;
			
			case 'squareTotalFrom':
				dispatch(
					Creators.setSquareTotalFrom(
						Number( parseFloat( value ).toFixed( 2 ) ),
					),
				);
				break;
			
			case 'squareTotalTo':
				dispatch(
					Creators.setSquareTotalTo(
						Number( parseFloat( value ).toFixed( 2 ) ),
					),
				);
				break;
			
			case 'totalCostFrom':
				dispatch( Creators.setTotalCostFrom( parseInt( value, 10 ) ) );
				break;
			
			case 'totalCostTo':
				dispatch( Creators.setTotalCostTo( parseInt( value, 10 ) ) );
				break;
			
			default:
				break;
		}
		
		// TODO:
		const state = getState();
		
		if ( state.common.visualMode )
		{
			const query = visualStateToQueryString(
				state.filter,
				state.visualData,
			);
			updateAddress( query );
			
			debouncedFetchVisualOverview( state.visualData.overview.view );
			
			if ( state.visualData.step > StateVisualStep.OVERVIEW )
			{
				debouncedFetchVisualBuilding(
					state.visualData.building.building,
					state.visualData.building.view,
				);
			}
			
			if ( state.visualData.step > StateVisualStep.BUILDING )
			{
				debouncedFetchVisualSection(
					state.visualData.section.section,
					state.visualData.section.view,
				);
			}
			
			if ( state.visualData.step > StateVisualStep.SECTION )
			{
				debouncedFetchVisualFloor(
					state.visualData.floor.floor,
				);
			}
		}
		else
		{
			const query = listStateToQueryString(
				state.filter,
			);
			updateAddress( query );
			debouncedFetchList( query );
		}
	}
}

/**
 * Module.
 */
export {
	FilterForm as default,
	FilterFormProps,
	FilterFormState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/FilterForm.tsx